import React from "react";

export const ItalicIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1667 4.66667V7.41667H12.1925L9.0575 14.75H6.5V17.5H13.8333V14.75H11.8075L14.9425 7.41667H17.5V4.66667H10.1667Z"
        fill="black"
        fill-opacity="0.54"
      />
    </svg>
  );
};
